import Breadcrumb from "../../../Breadcrumb/Breadcrumb";

const BodyPartCreatePage = () => {
  return (
    <div className="content">
      <div className="container-fluid">
        <div>
          <Breadcrumb
            currentPage={"Create Body Part"}
            links={[{ title: "Body Part List", path: "/body-parts" }]}
          />
        </div>

        <h1> Create Body Part </h1>
      </div>
    </div>
  );
};

export default BodyPartCreatePage;
